import { render, staticRenderFns } from "./OpenserveMplsVpnWizard.vue?vue&type=template&id=81932180&"
import script from "./OpenserveMplsVpnWizard.vue?vue&type=script&lang=js&"
export * from "./OpenserveMplsVpnWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports